export default "__VITE_ASSET__GqM31CKd__"